import {renderToStaticMarkup} from "react-dom/server";
import {getCitationFilePathHR} from "../../../../../services/agent-hr.service";


// Función para generar la tabla HTML
function objToTable(data) {
    /*data = [
        {Nombre: 'Juan', Edad: 30, Ciudad: 'Ciudad A'},
        {Nombre: 'María', Edad: 25, Ciudad: 'Ciudad B'},
        {Nombre: 'Pedro', Edad: 35, Ciudad: 'Ciudad A'},
    ];*/
    // Verificar si hay datos en el array
    if (data.length === 0) {
        return '';
    }

    // Obtener las propiedades de los objetos (encabezados de columna)
    const headers = Object.keys(data[0]);

    // Crear la estructura de la tabla
    let tablaHTML = renderToStaticMarkup(
        <div className="position-relative w-100">
            <div className="table-content table-responsive" style={{maxHeight: '70vh'}}>
                <table className="table table-bordered">
                    <thead>
                        <tr>
                        {headers.map((header) => {
                            const regex = /\[(.*?)\]/;
                            return (<th>{regex.exec(header)[1]}</th>)
                        })}
                        </tr>
                    </thead>
                    {data.map((row) => {
                            return (
                                <tbody>
                                    <tr>
                                        {headers.map((cel) => <td dangerouslySetInnerHTML={{__html: row[cel]}}/>)}
                                    </tr>
                                </tbody>
                            )
                        })
                    }
                </table>
            </div>
        </div>)

    return tablaHTML;
}

export const parseFollowUp = (data) => {
    const followupQuestions = [];
    if (data.followup) {
        data.followup.replace(/<<([^>>]+)>>/g, (match, content) => {
            followupQuestions.push(content);
            return "";
        });
        // trim any whitespace from the end of the answer after removing follow-up questions

    }
    return followupQuestions
}

export const parseEmailsToHtml = (text) => {
    // Define the regex pattern for matching emails
    const emailPattern = /[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}/g;
    let emails = text.match(emailPattern);
    emails = emails || [];
    // removing duplicates
    emails = emails.filter((value, index, self) => {
        return self.indexOf(value) === index;
    });
    // console.log('ANSWER EMAILS', emails)
    emails.forEach(element => {
        text = text.replaceAll(`${element}`, `<a href="mailto:${element}">${element}</a>`)
    });
    return text
}

export const parseUrlsToHtml = (text) => {
    // Define the regex pattern for matching URLs
    const urlPattern = /(?<=\[|\()(https?:\/\/[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}(?:\/[^\]\s]*)?)(?=\]|\))/g;
    let urls = text.match(urlPattern);
    urls = urls || [];
    // removing duplicates
    // console.log("UUUUURLS: ", urls)
    urls = urls.filter((value, index, self) => {
        return self.indexOf(value) === index;
    });
    urls.sort((a, b) => b.length - a.length);
    const fileExtensions = ['.docx', '.doc', '.pdf', '.jpg', '.jpeg' , '.png', '.gif', '.txt', '.xls', '.xlsx', '.ppt', '.pptx', '.zip', '.rar', '.7z'];    
    // Filter out URLs that end with common file extensions
    urls = urls.filter(url => {
        return !fileExtensions.some(ext => url.endsWith(ext));
    });
    urls.forEach(element => {
        const escapedUrl = element.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
        const regex = new RegExp(`(?<![@">])(${escapedUrl})`, 'g');
        text = text.replace(regex, (match, p1) => {
            if(element.indexOf("http") == 0)
                return `<a href="${element}" target="_blank" >${element}</a>`; 
            else
                return `<a href="https://${element}" target="_blank" >${element}</a>`; 
        });
    });
    return text
}

export const parseInsightsToHtml = (insights) =>{
    // removing title like ### Summary
    insights = insights.replaceAll('\n###', '')
    insights = insights.replaceAll('###', '')
    let special_keywords = ['Summary:', 'Summary', 'Next steps:', 'Next steps']
    for(let x in special_keywords)
        insights = insights.replace(`${special_keywords[x]}`, '')
    insights = insights.trim()

    // converting emails to html
    insights = parseEmailsToHtml(insights)

    // converting urls to html
    insights = parseUrlsToHtml(insights)
    return insights
}

export const parseAnswerToHtml = (answer, onCitationClicked, user, containerName, data, chatTheme) => {
    const citations = [];

    // Extract any follow-up questions that might be in the answer
    let parsedAnswer = answer.replace(/<<([^>>]+)>>/g, (match, content) => {
        // followupQuestions.push(content);
        return "";
    });
    parsedAnswer = parsedAnswer.replace(/\n/, '')
    parsedAnswer = parsedAnswer.trim();

    /// check if DAX data exist

    if(data.daxResult) {
        parsedAnswer = objToTable(data.daxResult);//  + parsedAnswer;
        // parsedAnswer = objToTable(data.daxResult) + parsedAnswer;
    }

    // converting emails to html
    // console.log("parse answer1:", parsedAnswer)
    parsedAnswer = parseEmailsToHtml(parsedAnswer)

    // converting urls to html
    console.log("parse answer:", parsedAnswer)
    parsedAnswer = parseUrlsToHtml(parsedAnswer)

    if (parsedAnswer.includes("**")) {
        /*parsedAnswer = parsedAnswer.replaceAll(' **', ' <b>')
        parsedAnswer = parsedAnswer.replaceAll('** ', '</b> ')*/
        parsedAnswer = parsedAnswer.replace(/\*\*(.*?)\*\*/g, function(match, content) {
            return '<b>' + content + '</b>';
        });
    }

    /*let linkAnswer = parsedAnswer;
    let pos = 0;
    while (parsedAnswer.includes('http', pos)) {
        pos = parsedAnswer.indexOf('http', pos);
        let i = pos + 1;
        while (parsedAnswer[i] !== ' ' && parsedAnswer[i] !== '\n' && parsedAnswer[i] !== ')' && i <= parsedAnswer.length) {
            i++;
        }
        let initString = parsedAnswer.substring(0, pos);
        let endString = parsedAnswer.substring(i + 1, parsedAnswer.length - 1);
        let url = parsedAnswer.substring(pos, i);

        parsedAnswer = initString + renderToStaticMarkup(<a href={url} rel="noopener noreferrer"
                                                            target="_blank">{url}</a>) + endString;
        // parsedAnswer = initString + url.link(url) + endString;

        pos = pos + url.length * 2 + 57;
    }*/

    // console.warn('MY TABLE', parsedAnswer)
    //verify if we have a table
    while (parsedAnswer.includes('|-') || parsedAnswer.includes('| -') || parsedAnswer.includes('|:-')  || parsedAnswer.includes('|')) {
        //initial and end position of the TABLE
        let init = parsedAnswer.indexOf('|');
        // let end = parsedAnswer.lastIndexOf('|');
        let end = parsedAnswer.indexOf('|\n\n') === -1 ?
            parsedAnswer.lastIndexOf('|') === -1 ?
                init + 1 : parsedAnswer.lastIndexOf('|') :
            parsedAnswer.indexOf('|\n\n');

        // console.log("ENDDDDD", end);

        //init string, end string between table, and table string
        let initString = parsedAnswer.substring(0, init);
        let endString = parsedAnswer.substring(end + 1, parsedAnswer.length);

        let tableString = parsedAnswer.substring(init, end + 1);
        /// to make sure the have all the rows
        tableString = tableString.replaceAll('||', '|\n|')
        // generate the table
        let rows = tableString.split('\n');
        parsedAnswer = renderToStaticMarkup(
            <div className="position-relative w-100">
                <p dangerouslySetInnerHTML={{__html: initString}}/>
                <div className="table-content table-responsive" style={{maxHeight: '70vh'}}>
                    <table className="table table-bordered" style={{
                        // color: "#fff",
                        color: chatTheme.answerText,
                    }}>
                        {rows.map((row, index) => {
                            const cels = row.split("|");
                            if (cels.length > 1 && index !== 1) {
                                // console.log(cels);
                                cels.pop();
                                cels.shift();
                                return (
                                    index === 0 ?
                                        <thead>
                                        <tr>
                                            {cels.map((cel) => <th dangerouslySetInnerHTML={{__html: cel}}/>)}
                                        </tr>
                                        </thead> :
                                        <tbody>
                                        <tr>
                                            {cels.map((cel) => <td dangerouslySetInnerHTML={{__html: cel}}/>)}
                                        </tr>
                                        </tbody>
                                )
                            }
                        })}
                    </table>
                </div>
                <p dangerouslySetInnerHTML={{__html: endString}}/>
            </div>
        );
    }


    const parts = parsedAnswer.split(/\[([^\]]+)\]/g);

    const fragments = parts.map((part, index) => {
        // console.log('PART' + index, part);

        if (index % 2 === 0) {
            return part;
        } else {
            let citationIndex;
            if (citations.indexOf(part) !== -1) {
                citationIndex = citations.indexOf(part) + 1;
            } else {
                citations.push(part);
                citationIndex = citations.length;
            }

            const path = getCitationFilePathHR(part, user.id, containerName);
            // console.log('path', path);

            return renderToStaticMarkup(
                <a className="supContainer" title={part} onClick={() => onCitationClicked(path)}>
                    <sup>{citationIndex}</sup>
                </a>
            );
        }
    });
    // console.log('RESULT', fragments.join(""), citations, followupQuestions);
    return {
        answerHtml: fragments.join(""),
        citations
    };
}

export const parseTextToHtml = (text, chatTheme) => {
    // Extract any follow-up questions that might be in the answer
    /*let parsedAnswer = text.replace(/<<([^>>]+)>>/g, (match, content) => {
        // followupQuestions.push(content);
        return "";
    });*/
    let parsedAnswer = text.trim() || "";

    if (parsedAnswer.includes("**")) {
        parsedAnswer = parsedAnswer.replace(/\*\*(.*?)\*\*/g, function(match, content) {
            return '<b>' + content + '</b>';
        });
    }

    let pos = 0;
    while (parsedAnswer.includes('http', pos)) {
        pos = parsedAnswer.indexOf('http', pos);
        let i = pos + 1;
        while (parsedAnswer[i] !== ' ' && parsedAnswer[i] !== '\n' && parsedAnswer[i] !== ')' && i <= parsedAnswer.length) {
            i++;
        }
        let initString = parsedAnswer.substring(0, pos);
        let endString = parsedAnswer.substring(i + 1, parsedAnswer.length - 1);
        let url = parsedAnswer.substring(pos, i);

        parsedAnswer = initString + renderToStaticMarkup(<a href={url} rel="noopener noreferrer"
                                                            target="_blank">{url}</a>) + endString;
        pos = pos + url.length * 2 + 57;
    }

    while (parsedAnswer.includes('|-') || parsedAnswer.includes('| -') || parsedAnswer.includes('|:-')) {
        let init = parsedAnswer.indexOf('|');
        let end = parsedAnswer.indexOf('|\n\n') === -1 ?
            parsedAnswer.lastIndexOf('|') === -1 ?
                init + 1 : parsedAnswer.lastIndexOf('|') :
            parsedAnswer.indexOf('|\n\n');

        //init string, end string between table, and table string
        let initString = parsedAnswer.substring(0, init);
        let endString = parsedAnswer.substring(end + 1, parsedAnswer.length);

        let tableString = parsedAnswer.substring(init, end + 1);

        // generate the table
        let rows = tableString.split('\n');
        parsedAnswer = renderToStaticMarkup(
            <div className="position-relative w-100">
                <p dangerouslySetInnerHTML={{__html: initString}}/>
                <div className="table-content table-responsive" style={{maxHeight: '70vh'}}>
                    <table className="table table-bordered" style={{
                        // color: "#fff",
                        color: chatTheme.answerText,
                    }}>
                        {rows.map((row, index) => {
                            const cels = row.split("|");
                            if (cels.length > 1 && index !== 1) {
                                // console.log(cels);
                                cels.pop();
                                cels.shift();
                                return (
                                    index === 0 ?
                                        <thead>
                                        <tr>
                                            {cels.map((cel) => <th>{cel}</th>)}
                                        </tr>
                                        </thead> :
                                        <tbody>
                                        <tr>
                                            {cels.map((cel) => <td dangerouslySetInnerHTML={{__html: cel}}/>)}
                                        </tr>
                                        </tbody>
                                )
                            }
                        })}
                    </table>
                </div>
                <p dangerouslySetInnerHTML={{__html: endString}}/>
            </div>
        );
    }
    return {
        textHtml: parsedAnswer
    };
}
